<script setup>
import { CampaignRegulatoryRequirement, getCampaignData } from '../../../utilities/investment-process/useCampaign'
import { formatDistance } from 'date-fns'
import { formatCurrency } from '../../../utilities/helpers'
import { computed } from 'vue'
import { de, fr, it } from 'date-fns/locale'
import BaseCard from '../../base/BaseCard.vue'

const currentLocale = computed(() => {
    if (document.querySelector('html').getAttribute('lang').startsWith('it')) {
        return it
    }
    if (document.querySelector('html').getAttribute('lang').startsWith('de')) {
        return de
    }
    if (document.querySelector('html').getAttribute('lang').startsWith('fr')) {
        return fr
    }
    return null
})
</script>

<template>
    <BaseCard class="overflow-hidden">
        <img class="w-full rounded-t-lg" :src="getCampaignData().asset_data.thumb_image" alt="" />
        <div class="bg-primary px-4 py-2 text-lg font-semibold tracking-wider text-white">
            {{
                $t('investment_process.time_left', {
                    time: formatDistance(new Date(getCampaignData().asset_data.funding_end), new Date(), {
                        locale: currentLocale,
                    }),
                })
            }}
        </div>
        <div class="text-gray-700">
            <h3 class="border-b border-gray-300 px-4 py-2 text-xl font-semibold">
                {{ getCampaignData().asset_data.asset_title }}
            </h3>
            <p class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('investment_process.issuer') }}</span>
                <span class="text-right">{{ getCampaignData().asset_data.company_name }}</span>
            </p>
            <p
                v-if="
                    getCampaignData().asset_data.regulatory_requirements !==
                    CampaignRegulatoryRequirement.STOCK_EMISSION
                "
                class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('investment_process.contract_period') }}</span>
                <span class="text-right">{{ getCampaignData().asset_data.contract_range }}</span>
            </p>
            <p class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('investment_process.minimum_investment') }}</span>
                <span
                    v-if="
                        getCampaignData().asset_data.regulatory_requirements !==
                        CampaignRegulatoryRequirement.STOCK_EMISSION
                    "
                    class="text-right">
                    {{
                        formatCurrency(
                            getCampaignData().asset_data.investment_min,
                            getCampaignData().asset_data.currency_string
                        )
                    }} </span
                ><span v-else class="text-right">
                    {{
                        formatCurrency(
                            getCampaignData().asset_data.minimum_investment,
                            getCampaignData().asset_data.currency_string
                        )
                    }}
                </span>
            </p>
            <p
                v-if="
                    getCampaignData().asset_data.regulatory_requirements ===
                    CampaignRegulatoryRequirement.STOCK_EMISSION
                "
                class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('investment_process.stock_price') }}</span>
                <span class="text-right">
                    {{
                        formatCurrency(
                            getCampaignData().asset_data.price_per_stock,
                            getCampaignData().asset_data.currency_string
                        )
                    }}
                </span>
            </p>
            <p class="flex justify-between px-4 py-2 text-sm text-gray-600 odd:bg-gray-100">
                <span class="font-semibold">{{ $t('investment_process.steps') }}</span>
                <span
                    v-if="
                        getCampaignData().asset_data.regulatory_requirements !==
                        CampaignRegulatoryRequirement.STOCK_EMISSION
                    "
                    class="text-right">
                    {{
                        formatCurrency(
                            getCampaignData().asset_data.step_level,
                            getCampaignData().asset_data.currency_string
                        )
                    }} </span
                ><span v-else class="text-right">
                    {{ getCampaignData().asset_data.stock_increments }}
                </span>
            </p>
        </div>
    </BaseCard>
</template>

<style scoped></style>
